<template>
    <div class="resource-card">
        <div class="pa-2 pa-lg-4">
            <div 
                class="subtitle-2 primary--text" 
                v-text="subjectFormatted"
            ></div>
            <div class="title mt-2 mb-7" v-text="resource.title"></div>
            <template v-if="resource.type == 0">
                <v-btn
                    rounded
                    depressed
                    small
                    color="primary"
                    @click="previewResourceEventHandler"
                >Read more</v-btn>
            </template>
            <template v-if="resource.type == 1">
                <v-btn
                    :href="`${baseImageUrl}${resource.file}`"
                    rounded
                    depressed
                    small
                    color="primary"
                    target="_blank"
                ><v-icon left small>mdi-download</v-icon> {{ $t('Document') }}</v-btn>
            </template>
            <template v-if="resource.type == 2">
                <v-btn                        
                    rounded
                    depressed
                    small
                    color="primary"
                    @click="previewResourceEventHandler"
                ><v-icon left small>mdi-play</v-icon> {{ $t('Video') }}</v-btn>
            </template>
        </div>
        <div>
            <template v-if="resource.type == 0">
                <div 
                    class="image-container"
                    :style="`background-image: url('${baseImageUrl}${resource.image}')`"
                ></div>
            </template>
            <template v-else-if="resource.type == 1">
                <div class="image-container">
                    <img src="@/assets/images/document.svg"/>
                </div>
            </template>
            <template v-else-if="resource.type == 2">
                <div class="image-container">
                    <v-icon color="primary">mdi-play</v-icon>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    
    export default {
        name: 'resourceCard',
        props: {
            resource: {
                type: Object,
                default: () => ({
                    id: 0,
                    type: null,
                    description: '',
                    documentTitle: '',
                    file: '',
                    image: '',
                    title: '',
                    videoLink: ''
                })
            }
        },
        computed: {
            ...mapGetters(['baseImageUrl']),
            subjectFormatted() {
                return `${this.resource.teachingSubject.label} (${this.resource.educationLevel.label})`
            }
        },
        methods: {
            previewResourceEventHandler() {
                this.$EventBus.$emit('previewResource', this.resource)
            }
        }
    }
</script>

<style lang="scss" scoped>
.resource-card{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    border: 1px solid $primary;
    border-radius: 15px;
    background-color: #fff;
    overflow: hidden;
    @include transition(all .2s ease);
    &:hover{
        @include transform(translateY(-1px));
        @include shadow(0px 5px 10px -5px rgba(0,0,0,0.3));
    }
    .row{
        height: 100%;
    }
    .image-container{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 125px;
        min-width: 125px;
        height: 100%;
        background-color: #f5f5f5;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: top center;
        color: $primary;
        text-decoration: none;
        .v-icon{
            font-size: 4rem;
        }
    }
}
@media (max-width: 599px) {
    .resource-card{
        .image-container{
            width: 85px;
            min-width: 85px;
        }
    }
}
</style>